import { Link } from "react-router-dom";
import { AI_HERO_GIF, AI_BG_NEW } from "../../images";
import { useModal } from "../../utils/demoProvider";

export const Hero = ({ observedRef }) => {
  const { openModal } = useModal();
  return (
    <section
      style={{
        backgroundImage: `url("${AI_BG_NEW}")`,
        backgroundSize: "cover",
      }}
      className="min-h-[100vh] flex items-center bg-left md:bg-center"
      ref={observedRef}
    >
      <div className="container mx-auto w-full h-full xl:max-h-screen flex flex-col md:flex-row justify-between items-center gap-0 md:gap-16 xl:gap-16  pt-[126px] pb-0 md:pt-[96px] md:py-[96px]">
        <div className="flex basis-2/4 flex-col flex-wrap gap-[36px] items-start">
          <div className="space-y-4">
            <h2 className="text-[38px] md:text-[54px] text-center md:text-left font-extrabold leading-[1.3] md:leading-[64px] text-white">
              Precision AI <br className="hidden md:block" /> Evaluation & Data
              <br className="hidden md:block" />
              Labeling at Scale
            </h2>
            <p className="text-base md:text-lg text-center md:text-left font-medium text-[#88BEFF] md:text-[#FFF] leading-5">
              Delivering context-aware annotations and model evaluations that
              bridge global AI technology with accuracy.
            </p>
          </div>
          <div className="flex justify-center md:justify-start items-center w-full gap-4 md:gap-8">
            <Link to="/contact">
              <button className="text-sm md:text-base font-semibold py-3 w-[170px] text-center bg-[#0073FF] hover:bg-poppingBlue/70 text-white rounded-[100px] gap-2 transition-colors ease-in duration-300">
                Learn More
              </button>
            </Link>

            <button
              className="text-sm md:text-base text-[#0073FF] font-semibold py-3 w-[170px] text-center bg-white text-poppingBlue hover:bg-white/90 rounded-[100px] transition-colors ease-in duration-300"
              onClick={openModal}
            >
              Book A Demo
            </button>
          </div>
        </div>
        <div className="basis-2/4 flex justify-center items-center h-full">
          <img
            className="w-full object-cover min-h-[550px] md:min-h-[630px] xl:min-h-[700px] 2xl:min-h-[900px]"
            src={AI_HERO_GIF}
            alt="illustration"
          />
        </div>
      </div>
    </section>
  );
};
